import { FunctionComponent } from "react";

import NotificationsButtonBase from "./components/NotificationsButtonBase/NotificationsButtonBase";
import * as styles from "./NotificationsButton.css";

interface NotificationsButtonProps {
  Logo?: FunctionComponent<{ className?: string }>;
  popoverId?: string;
  popoverClassName?: string;
}

const NotificationsButton: FunctionComponent<NotificationsButtonProps> = ({
  Logo,
  popoverId,
  popoverClassName,
}) => {
  return (
    <>
      <div className={styles.breakpointFrom.navigation}>
        <NotificationsButtonBase
          type="standard"
          popoverClassName={popoverClassName}
          Logo={Logo}
          popoverId={popoverId}
        />
      </div>
      <div className={styles.breakpointTill.navigation}>
        <NotificationsButtonBase
          type="mobile"
          popoverClassName={popoverClassName}
          Logo={Logo}
          popoverId={popoverId}
        />
      </div>
    </>
  );
};

export default NotificationsButton;
